import type { Timeframe } from './types';

export const TIME_FRAMES: Array<{ value: Timeframe; label: string }> = [
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'year', label: 'Year' },
];

/** Fixed color palette so a category keeps its color across charts. */
export const CATEGORY_COLORS: Record<string, string> = {
  Food: '#f43f5e',
  Bills: '#f59e0b',
  'Food & Dining': '#fb7185',
  'Bills & Utilities': '#fbbf24',
  Shopping: '#d946ef',
  'Subscriptions': '#a78bfa',
  Transport: '#06b6d4',
  Rent: '#f97316',
  'Medical / Health': '#ef4444',
  Education: '#3b82f6',
  Income: '#10b981',
  Salary: '#10b981',
  'Bonus / Incentive': '#34d399',
  'Interest / Dividends': '#6ee7b7',
  Freelance: '#10b981',
  'Rental Income': '#34d399',
  Investment: '#10b981',
  'Mutual Funds': '#10b981',
  'Stocks / Equity': '#06b6d4',
  'FD / RD': '#14b8a6',
  Gold: '#fbbf24',
  Crypto: '#a78bfa',
  Loan: '#f59e0b',
  EMI: '#f59e0b',
  'Credit Card': '#fb923c',
  'Personal Loan': '#f97316',
  'Home Loan': '#ea580c',
  Other: '#52525b',
  'Charity / Donations': '#71717a',
  Gifts: '#a1a1aa',
  Pets: '#d4d4d8',
  Miscellaneous: '#52525b',
};
